import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction'
import Modal from "react-modal";

Modal.setAppElement("#root");
export default function SpiceBg() {
    const [fname12, setfname12] = useState("");
    const [newFile12, setNewFile12] = useState(null);
    const [newdata12, setNewData12] = useState([]);
  
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    
    const handleImageClick = (imageSrc) => {
      setSelectedImage(imageSrc);
      setIsModalOpen(true);
    };
    
    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
  
    const setData12 = (e) => {
      const { value } = e.target;
      setfname12(value);
    };
    const setimgfile = (e) => {
      setNewFile12(e.target.files[0]);
    };
  
    // Add image
  
    const addUserData12 = async (e) => {
      
      var formData12 = new FormData();
      console.log(newFile12);
      var filename = newFile12.name;
      formData12.append("photo12", newFile12, filename);
      formData12.append("fname12", fname12);
      console.log(formData12);
  
      const config = {
        headers: {
          "Content-Type": " multipart/form-data",
        },
      };
  
      const res = await axios.post(
        "https://pratik-agro-backend.vercel.app/AddSpiceBgimg",
        formData12,
        config
      );
  
      console.log(res);
    };
    //get image
  
    const getUserData12 = async () => {
      const res12 = await axios.get("https://pratik-agro-backend.vercel.app/getSpiceBgimg", {
        headers: {
          "Content-Type": " application/json",
        },
      });
      if (res12.data.status === 401 || !res12.data) {
        console.log("error");
      } else {
        setNewData12(res12.data.getImage.reverse());
      }
    };
    useEffect(() => {
      getUserData12();
    }, []);
   
  //delete data
  const deleteimage = async (id) => {
   
    const res6 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata12/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const deleteStud = await res6.json();
    console.log(deleteStud);
    if (res6.status === 422 || !deleteStud) {
      console.log("error");
    } else {
      getUserData12();
    }
  
  };
  return (
    <div className='content'>
     
     <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Background</h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
      <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  Spices BackgroundImage 
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}>Background Image Name:-</p>
                    
                    <input
                      type="text"
                      name="fname12"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData12}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo12"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                       onClick={addUserData12}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="outer-wrapper">
    <div class="table-wrapper"> 
      <table class="table  mt-5">
        <thead className="bg-dark text-white">
          <tr>
            <th scope="col">ID</th>
            <th scope="col"> Background Image</th>
            <th scope="col"> Image Name</th>
            <th scope="col">Uploaded Date</th>
            <th scope="col">Action</th>
            
          </tr>
        </thead>
        <tbody>
          {newdata12.length>0?newdata12.map((el,id) => {
            console.log(el)
            return (
              <>
                <tr>
                  <th scope="row mt-5">{id+1}</th>
                  <td><img src={el.SpiceBgimg} alt='img'  style={{'width':'70px',textAlign:"center",margin:'auto',cursor:"pointer" }}onClick={() => handleImageClick(el.SpiceBgimg)}/></td>
                  <td>{el.fname12}</td>
                  <td>{el.date}</td>
                  {/* <td>
                    <NavLink to={`/Edit/${el._id}`}><i className="bi bi-pencil-square p-4 shadow"  ></i></NavLink>
                    <i class="bi bi-archive-fill p-4 shadow" onClick={()=>deleteimage(el._id)}></i>
                  </td> */}
                  <td>
                        <button type="button" class="btn btn-outline-dark "><NavLink to={`/SpiceBgEdit/${el._id}`}><i className="bi bi-pencil-square "  ></i></NavLink></button>
                        <button type="button" class="btn btn-outline-dark "><i class="bi bi-archive-fill " onClick={()=>deleteimage(el._id)}></i></button>
                  </td>
                </tr>
              </>
            );
          }):"Loading..."
          } 
        </tbody>
        <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal}>
  <img src={selectedImage} alt="img" style={{width: '100%', height: 'auto'}} className='img-fluid' />
</Modal>
      </table>
      </div>
      </div>
    </div>
  )
}

